import { render, staticRenderFns } from "./SectionItem.vue?vue&type=template&id=44e214f9&scoped=true"
import script from "./SectionItem.vue?vue&type=script&lang=js"
export * from "./SectionItem.vue?vue&type=script&lang=js"
import style0 from "./SectionItem.vue?vue&type=style&index=0&id=44e214f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e214f9",
  null
  
)

export default component.exports